<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
body {
  padding: 0;
  margin: 0;
}
#nprogress .bar {
  background: #33c0f7 !important;
}
/* 样式定义 */
::-webkit-scrollbar {
  width: 6px; /* 滚动条宽度 */
  height: 6px; /* 滚动条高度 */
}

::-webkit-scrollbar-track {
  background-color: #f5f5f5; /* 滚动条背景色 */
  border-radius: 3px; /* 滚动条边框圆角 */
}

::-webkit-scrollbar-thumb {
  background-color: #ccc; /* 滚动条滑块颜色 */
  border-radius: 3px; /* 滚动条滑块边框圆角 */
}

::-webkit-scrollbar-thumb:hover {
  background-color: #999; /* 滚动条滑块鼠标悬停颜色 */
}
</style>



// WEBPACK FOOTER //
// src/App.vue